/**
 * ENUM
 * Normaliza codigos de formas de pagamento.
 *
 * @author hjCostaBR
 */
export const PaymentMethodsEnum = {
    BANK_BILLET : {
        code: 0,
        name: "Boleto"
    },

    CREDIT_CARD : {
        code: 1,
        name: "Cartão de Crédito"
    }
}



// WEBPACK FOOTER //
// ./src/enums/PaymentMethodsEnum.js